/**
 * @author Jean-Louis Mainguy <jean-louis.mainguy@cossette.com>
 * @file TextImage
 * @description module text with image or illustration
 */

export class WalkTheTalk {

  // ATTRIBUTS //
  private modules:NodeListOf<HTMLElement>;
  private gsap:any
  private amountOfSlides:number
  private slideIterator:number = 0

  // METHODS //
  /**
   * Constructor & initialise
   */
  public constructor(gsap, amountOfSlides:number) {
    this.gsap = gsap
    this.amountOfSlides = amountOfSlides;
    this.modules = document.querySelectorAll('.walk-the-talk-wrapper');

    this.init();
  }


  /**
   * Define the initial state
   */
  private init():void {

    const mm = this.gsap.matchMedia()

    mm.add("(min-width: 600px)", () => {

      this.modules.forEach(module => {
        const arrowRight = module.querySelector('.arrow--next')
        const arrowLeft = module.querySelector('.arrow--prev')
        arrowRight.addEventListener('click', this.handleArrowClick.bind(this))
        arrowLeft.addEventListener('click', this.handleArrowClick.bind(this))
      })

    });

  }

  private handleArrowClick(e:MouseEvent):void {
    const target:HTMLElement = e.currentTarget as HTMLElement

    // based on attribute "dir" we know if we need to go left or right
    const dir = target.getAttribute('dir')
    const dirValue = dir === 'prev' ? 1 : -1;
    const elWidth = (target.parentElement.parentElement.querySelector('.swiper-wrapper>div') as HTMLElement).offsetWidth
    
    // translate "swiper-wrapper" on X axis by the width of the element
    const swiperWrapper = target.parentElement.parentElement.querySelector('.swiper-wrapper') as HTMLElement
    const currentTranslateX = swiperWrapper.style.transform ? Math.floor(parseInt(swiperWrapper.style.transform.split('(')[1].split('px')[0]) / elWidth) : 0
    const newTranslateX = currentTranslateX * elWidth + (elWidth * dirValue)

    // make sure it's not out of bounds
    if (newTranslateX > 0 || newTranslateX < -((elWidth * swiperWrapper.children.length) - elWidth)) {
      return
    }
    // stop if no more tile need to be shown
    if (dir === 'next' && ((elWidth * swiperWrapper.children.length) + newTranslateX) < document.querySelector('body').offsetWidth - elWidth) {
      return
    }
    const disabledButton:HTMLElement = target.parentElement.parentElement.querySelector('.arrow--disable')
    if(disabledButton) {
      disabledButton.classList.remove('arrow--disable')
    }
    if (newTranslateX == 0 || newTranslateX < -((elWidth * swiperWrapper.children.length) - elWidth)) {
      target.classList.add('arrow--disable')
    }
    if (dir === 'next' && ((elWidth * swiperWrapper.children.length) + newTranslateX - elWidth) < document.querySelector('body').offsetWidth - elWidth) {
      target.classList.add('arrow--disable')
    }


    // Animate using gsap tween
    this.gsap.to(swiperWrapper, {
      duration: 0.3,
      x: newTranslateX,
      ease: 'power2.out'
    })

  }

}
